import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { USER_PLAN_SERVICE_METHOD } from "services/commonService";
import { deleteMyPlansAsync } from "../MyPlans/myplans.slice";
import { submitSuggestedPlansFeedbackAsync } from "../library/SuggestedPlans/SuggestedPlans.slice";

const SLICE = "Feedback";

export interface FeedbackState {
  feedbackLoader: boolean;
  feedbackForms: any;
  formDetails: any;
  questionCategories: any;
  submitFeedbackForPopUps: {
    shouldSubmitFeedback: boolean;
    data: any;
  };
}

const initialState: FeedbackState = {
  feedbackLoader: false,
  feedbackForms: [],
  formDetails: [],
  questionCategories: {
    list: [],
    values: []
  },
  submitFeedbackForPopUps: {
    shouldSubmitFeedback: false,
    data: {}
  }
};

export const fetchFeedbackForms = createAsyncThunk(`${SLICE}/fetchFeedbackForms`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getFeedbackForms, {}, thunkApi, [], data)
);

export const fetchFeedbackFormDetails = createAsyncThunk(`${SLICE}/fetchFeedbackFormDetails`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getFeedbackForm, {}, thunkApi, [data.id])
);

export const fetchFeedbackFormsQuestionsCategories = createAsyncThunk(
  `${SLICE}/fetchFeedbackFormsQuestionsCategories`,
  (thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.getFeedbackFormsQuestionsCategories, {}, thunkApi)
);

export const updateFeedback = createAsyncThunk(`${SLICE}/updateFeedback`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.putFeedbackForms, data, thunkApi)
);

export const submitFeedback = createAsyncThunk(`${SLICE}/submitFeedback`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.postFeedback, data, thunkApi)
);

export const FeedbackSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...initialState,
        questionCategories: state.questionCategories,
        submitFeedbackForPopUps: state.submitFeedbackForPopUps
      };
    },
    saveFormData: (state, action) => {
      state.submitFeedbackForPopUps.data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeedbackForms.fulfilled, (state, action: any) => {
        state.feedbackLoader = false;
        state.feedbackForms = action.payload;
      })
      .addCase(fetchFeedbackFormsQuestionsCategories.fulfilled, (state, actions) => {
        state.questionCategories.list = actions.payload.categories;
        state.questionCategories.values = actions.payload.categories.map((item: any) => {
          return { [item.category]: item.category };
        });
      })
      .addCase(fetchFeedbackFormDetails.fulfilled, (state, actions) => {
        state.formDetails = actions.payload;
        state.feedbackLoader = false;
      })
      .addCase(submitFeedback.fulfilled, (state) => {
        state.feedbackLoader = false;
        state.submitFeedbackForPopUps.shouldSubmitFeedback = false;
        state.submitFeedbackForPopUps.data = {};
      })
      .addMatcher(isFulfilled(deleteMyPlansAsync, submitSuggestedPlansFeedbackAsync), (state) => {
        state.submitFeedbackForPopUps.shouldSubmitFeedback = true;
      })
      .addMatcher(isRejected(deleteMyPlansAsync, submitSuggestedPlansFeedbackAsync), (state) => {
        state.submitFeedbackForPopUps.shouldSubmitFeedback = false;
        state.submitFeedbackForPopUps.data = {};
      })
      .addMatcher(isPending(submitFeedback, fetchFeedbackForms, fetchFeedbackFormDetails), (state) => {
        state.feedbackLoader = true;
      })
      .addMatcher(isRejected(submitFeedback, fetchFeedbackForms, fetchFeedbackFormDetails), (state) => {
        state.feedbackLoader = false;
      });
  }
});

export const { reset, saveFormData } = FeedbackSlice.actions;

export default FeedbackSlice.reducer;
